export default {
  UNKNOWN: 'UNKNOWN',
  STRING: 'String',
  DATE: 'Date',
  BOOL: 'Boolean',
  CURRENCY: 'Currency',
  CURRENCY_WITHOUT_CENT: 'Currency_without_cent',
  ENUM: 'Enum',
}
